import { render } from "./Automotive.vue?vue&type=template&id=13d65c56"
import script from "./Automotive.vue?vue&type=script&lang=js"
export * from "./Automotive.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__